import { inject } from '@angular/core';
import { CanMatchFn, GuardResult, Router } from '@angular/router';
import { SessionStoreRepository } from '../../repositories/session.repository';

export const canMatchDoctor: CanMatchFn = (): GuardResult => {
    return !inject(SessionStoreRepository).isPatient || inject(Router).createUrlTree(["/authenticated"]);
};

export const canMatchPatient: CanMatchFn = (): GuardResult => {
    return inject(SessionStoreRepository).isPatient || inject(Router).createUrlTree(["/authenticated"]);
};